import React, {Fragment} from 'react';
import PageTitle from '../../components/pagetitle/PageTitle'
import ServicesCard from './ServicesCard';
import Scrollbar from '../../components/scrollbar/scrollbar'
const Services =() => {
    return(
        <Fragment>
            <PageTitle pageTitle={'Services'} pagesub={'Services'}/> 
            <ServicesCard sClass={'service-pg-service-section-s2 '}/>
            <Scrollbar/>
        </Fragment>
    )
};
export default Services;

